import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Loading, Notify } from "vant";

axios.interceptors.request.use(
    config => {
        // if (!config.headers.Authorization && config.headers.Authorization !== null)
        // config.headers.Authorization="Bearer "+window.localStorage.getItem("token")
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        console.log(
            err.response.status,
            "==============err======================="
        );
        switch (err.response.status) {
            //   case 401:
            //     Notify({ type: "danger", message: "身份登录已过期，请重新登录" });
            //     let query = { redirect: router.path };
            //     store.commit("main/LOGOUT");
            //     router.push({ path: "/login", query: query });
            //     break;
            case 403:
                Notify({ type: "danger", message: "不允许访问" });
                break;
            case 404:
                Notify({ type: "danger", message: "网络请求不存在" });
                break;
            case 500:
                Notify({ type: "danger", message: "服务器正在维护，请稍后再试" });
                break;
            case 503:
                Notify({ type: "danger", message: "服务器正在维护，请稍后再试" });
                break;

            default:
                Notify({ type: "danger", message: err.response.data.message });
                break;
        }
        return Promise.reject(err);
    }
);

export default axios;



// WEBPACK FOOTER //
// ./src/axios/index.js